import { render } from "./VehicleWarranty.vue?vue&type=template&id=5be0c938&scoped=true"
import script from "./VehicleWarranty.vue?vue&type=script&lang=js"
export * from "./VehicleWarranty.vue?vue&type=script&lang=js"

import "./VehicleWarranty.vue?vue&type=style&index=0&id=5be0c938&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be0c938"]])

export default __exports__